module.exports = __webpack_public_path__ + "static/img/news4_1.04b1d25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news4_1.jpg
// module id = 6Lyn
// module chunks = 0